import React from "react";
import { Button } from "react-bootstrap";

export default function CTA({ randomLocXuan, exportImage }) {
  return (
    <>
      <Button
        variant={"danger"}
        onClick={randomLocXuan}
        size={"md"}
        style={{ fontFamily: "Bangers" }}
      >
        Hái Lộc Lời Chúa
      </Button>
      &nbsp;
      <Button
        variant={"primary"}
        onClick={exportImage}
        size={"md"}
        style={{ fontFamily: "Bangers" }}
      >
        Tải về máy
      </Button>
    </>
  );
}
